const menuButton=document.querySelector('.menu');
const mobileNav=document.querySelector('#mobile-nav');
menuButton.addEventListener('click',()=>{const open=menuButton.getAttribute('aria-expanded')==='true';menuButton.setAttribute('aria-expanded',String(!open));menuButton.setAttribute('aria-label',open?'Open navigation':'Close navigation');mobileNav.hidden=open;});
mobileNav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{mobileNav.hidden=true;menuButton.setAttribute('aria-expanded','false');menuButton.setAttribute('aria-label','Open navigation');}));
const tabs=[...document.querySelectorAll('[role="tab"]')];
function activate(name,focus=false){tabs.forEach(t=>{const on=t.dataset.tab===name;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;document.querySelector('#'+t.getAttribute('aria-controls')).hidden=!on;if(on&&focus)t.focus();});softEnter(document.querySelector('#panel-'+name));}
tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab.dataset.tab));tab.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(i+1)%tabs.length;if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(i-1+tabs.length)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();activate(tabs[next].dataset.tab,true);}});});
const model=document.querySelector('#plan-model'),size=document.querySelector('#plan-size'),boxes=document.querySelector('#plan-boxes'),status=document.querySelector('#copy-status');
function summary(){const n=Number(boxes.value),valid=Number.isInteger(n)&&n>=1&&n<=999;document.querySelector('#summary-line').textContent=valid?`${model.value} · ${size.value}″ · ${n} ${n===1?'box':'boxes'}`:'Enter 1–999 whole boxes';document.querySelector('#summary-total').textContent=valid?`${(n*50).toLocaleString()} blades`:'—';status.textContent='Prepare a list to share with our team. No order is placed.';return valid?`Fartilo ${model.value} | ${size.value}" | ${n} ${n===1?'box':'boxes'} | ${n*50} blades (50 pcs/box)`:null;}
[model,size,boxes].forEach(el=>el.addEventListener('input',summary));
document.querySelectorAll('.plan-trigger').forEach(btn=>btn.addEventListener('click',()=>{model.value=btn.dataset.model;summary();activate('plan');document.querySelector('#shop-tools').scrollIntoView({behavior:motionReduced()?'instant':'smooth'});document.querySelector('#tab-plan').focus({preventScroll:true});}));
document.querySelector('#order-planner').addEventListener('submit',async e=>{e.preventDefault();const text=summary();if(!text)return;try{await navigator.clipboard.writeText(text);status.textContent='Copied. Share this line with our team for pricing and availability.';}catch{status.textContent=text+' — Select and copy this order line.';}});

const productViews={
 799:{engineering:{src:'',alt:'Original 799 engineering render showing the beam body and connector options',caption:'01 / BEAM PROFILE & CONNECTORS'},detail:{src:'',alt:'Actual 799 sample photo showing the central connector and locking details',caption:'02 / CONNECTOR · ACTUAL SAMPLE'},pack:{src:'',alt:'Reference-based concept of the 799 blade with blue-accented individual packaging',caption:'03 / INDIVIDUAL PACK · CONCEPT'}},
 818:{engineering:{src:'',alt:'Original 818 engineering render showing its jointed steel frame',caption:'01 / MULTI-BRIDGE FRAME'},detail:{src:'',alt:'Actual 818 sample photo showing the rubber edge and metal supporting strips',caption:'02 / WIPING EDGE · ACTUAL SAMPLE'},pack:{src:'',alt:'Reference-based concept of the 818 blade with orange-accented individual packaging',caption:'03 / INDIVIDUAL PACK · CONCEPT'}}
};
const imageRequests=new Map();
document.querySelectorAll('[data-image-model]').forEach(button=>button.addEventListener('click',async()=>{
 const m=button.dataset.imageModel,view=button.dataset.view,data=productViews[m][view],img=document.querySelector('#image-'+m),stage=img.parentElement;
 if(button.getAttribute('aria-pressed')==='true'&&!stage.hasAttribute('aria-busy'))return;
 const request=(imageRequests.get(m)||0)+1;imageRequests.set(m,request);stage.setAttribute('aria-busy','true');
 const incoming=new Image();incoming.src=data.src;
 try{await Promise.race([incoming.decode(),new Promise((_,reject)=>setTimeout(()=>reject(new Error('Image load timeout')),8000))]);}
 catch{if(imageRequests.get(m)===request){stage.removeAttribute('aria-busy');document.querySelector('#caption-'+m).textContent='Image unavailable. Please try again.';}return;}
 if(imageRequests.get(m)!==request)return;
 stage.querySelectorAll('.image-outgoing').forEach(el=>el.remove());
 const previous=img.cloneNode();previous.removeAttribute('id');previous.alt='';previous.setAttribute('aria-hidden','true');previous.className='image-outgoing';previous.style.objectFit=getComputedStyle(img).objectFit;
 img.src=data.src;img.alt=data.alt;stage.dataset.view=view;stage.removeAttribute('aria-busy');
 document.querySelector('#caption-'+m).textContent=data.caption;
 document.querySelectorAll(`[data-image-model="${m}"]`).forEach((b,i)=>{const selected=b===button;b.classList.toggle('selected',selected);b.setAttribute('aria-pressed',String(selected));if(selected)b.parentElement.style.setProperty('--view-index',String(i));});
 if(!motionReduced()&&typeof img.animate==='function'){
  stage.append(previous);const fade=previous.animate([{opacity:1},{opacity:0}],{duration:360,easing:'ease-out'});fade.finished.then(()=>previous.remove(),()=>previous.remove());
  img.animate([{transform:'scale(1.025)'},{transform:'scale(1)'}],{duration:500,easing:'cubic-bezier(.2,.7,.2,1)'});
 }
}));

const marginModel=document.querySelector('#margin-model'),marginTier=document.querySelector('#margin-tier'),marginCost=document.querySelector('#margin-cost'),marginSale=document.querySelector('#margin-sale'),marginOther=document.querySelector('#margin-other');
const wholesaleBaseCents={799:1440,818:1080};
const volumeTiers={base:{label:'1–2 boxes',discount:0},volume:{label:'3–9 boxes',discount:.10},dealer:{label:'10–29 boxes',discount:.15},bulk:{label:'30+ boxes',discount:.20}};
function wholesaleCost(model,tier){return Math.round(wholesaleBaseCents[model]*(1-volumeTiers[tier].discount))/100;}
function calculateContribution(cost,sale,other){if(![cost,sale,other].every(Number.isFinite)||cost<0||sale<=0||other<0)return null;const cents=Math.round(sale*100)-Math.round(cost*100)-Math.round(other*100);return {amount:cents/100,percent:cents/Math.round(sale*100)*100};}
const dollars=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});
function updateMargin(){const fields=[marginCost,marginSale,marginOther],complete=fields.every(f=>f.value.trim()!==''&&f.validity.valid),result=complete?calculateContribution(...fields.map(f=>Number(f.value))):null;document.querySelector('#margin-result').textContent=result?dollars.format(result.amount):'—';document.querySelector('#margin-percent').textContent=result?result.percent.toFixed(1)+'%':'—';if(result)softEnter(document.querySelector('.calc-results'),4);document.querySelector('.calc-results').classList.toggle('negative',!!result&&result.amount<0);document.querySelector('#margin-message').textContent=!result?'Enter a positive selling price and non-negative costs (up to two decimals).':result.amount<0?'Your entered selling price does not cover these direct costs.':result.amount===0?'This selling price covers the entered direct costs, with no contribution left.':'Estimated contribution per blade, before fixed overhead and income tax.';}
function useWholesaleCost(){const tier=volumeTiers[marginTier.value],cost=wholesaleCost(marginModel.value,marginTier.value);marginCost.value=cost.toFixed(2);document.querySelector('#cost-hint').textContent=`20″ blade · ${tier.label}${tier.discount?' · '+Math.round(tier.discount*100)+'% off':''} · ${dollars.format(cost)} per blade. Editable.`;updateMargin();}
[marginModel,marginTier].forEach(el=>el.addEventListener('change',useWholesaleCost));[marginCost,marginSale,marginOther].forEach(el=>el.addEventListener('input',()=>{if(el===marginCost)document.querySelector('#cost-hint').textContent='Using your custom blade cost. Changing product or volume restores the 20″ example price.';updateMargin();}));
document.querySelector('#margin-calculator').addEventListener('submit',e=>{e.preventDefault();updateMargin();});


// Motion is progressive enhancement: content stays available without JavaScript.
function motionReduced(){return matchMedia('(prefers-reduced-motion: reduce)').matches||document.documentElement.dataset.motion==='off';}
function softEnter(element,distance=10){
 if(!element||motionReduced()||typeof element.animate!=='function')return;
 element.getAnimations().forEach(a=>a.cancel());
 element.animate([{opacity:.45,transform:`translateY(${distance}px)`},{opacity:1,transform:'translateY(0)'}],{duration:320,easing:'cubic-bezier(.2,.7,.2,1)'});
}
(function setupMotion(){
 const root=document.documentElement,button=document.querySelector('#motion-toggle'),preference=matchMedia('(prefers-reduced-motion: reduce)');
 let manualOff=false;try{manualOff=sessionStorage.getItem('fartilo-motion')==='off';}catch{}
 let observer;const revealTargets=[...document.querySelectorAll('.benefit-grid>div,.section-head,.product,.fitment-note,.margin-copy,.margin-calculator,.pricing-card,.dealer-card,.tools-copy,.tool-panel,.service-grid article,.wholesale-inner')];
 function syncMotion(){
  const off=manualOff||preference.matches;root.dataset.motion=off?'off':'on';button.setAttribute('aria-pressed',String(!off));button.setAttribute('aria-label',off?'Enable page motion':'Pause page motion');button.querySelector('span').textContent=off?'Motion off':'Pause motion';
  if(off){observer?.disconnect();root.classList.remove('reveal-enabled');document.getAnimations().forEach(a=>a.cancel());document.querySelectorAll('.image-outgoing').forEach(el=>el.remove());}
  else if('IntersectionObserver' in window){
   root.classList.add('reveal-enabled');observer?.disconnect();observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px -24px 0px'});
   revealTargets.forEach(el=>{el.classList.add('reveal');if(el.getBoundingClientRect().top<innerHeight*.92)el.classList.add('is-visible');if(!el.classList.contains('is-visible'))observer.observe(el);});
  }
 }
 button.hidden=false;button.addEventListener('click',()=>{if(preference.matches)return;manualOff=!manualOff;try{sessionStorage.setItem('fartilo-motion',manualOff?'off':'on');}catch{}syncMotion();});
 preference.addEventListener('change',()=>{button.disabled=preference.matches;syncMotion();});button.disabled=preference.matches;
 document.addEventListener('focusin',e=>{e.target.closest('.reveal')?.classList.add('is-visible');});
 document.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',()=>{const id=link.getAttribute('href').slice(1),target=id&&document.getElementById(id);if(target){target.classList.add('is-visible');target.querySelectorAll('.reveal').forEach(el=>el.classList.add('is-visible'));}}));
 try{syncMotion();}catch{root.classList.remove('reveal-enabled');}
 const header=document.querySelector('header');let queued=false;
 function updateHeader(){header.classList.toggle('scrolled',scrollY>40);queued=false;}
 addEventListener('scroll',()=>{if(!queued){requestAnimationFrame(updateHeader);queued=true;}},{passive:true});updateHeader();
})();

// First-order promotion. Claiming opens the existing contact flow; no checkout code is simulated.
(function setupFirstOrderOffer(){
 const dialog=document.querySelector('#first-order-offer'),launcher=document.querySelector('#offer-launcher');
 if(typeof dialog.showModal!=='function')return;
 const key='fartilo-first-order-offer-v10',week=7*24*60*60*1000;
 let shown=false,remaining=10000,timer=null,started=0,returnFocus=null;
 try{const dismissed=Number(localStorage.getItem(key));shown=dismissed>0&&Date.now()-dismissed<week;shown=shown||sessionStorage.getItem(key)==='shown';}catch{}
 function pauseTimer(){if(timer!==null){clearTimeout(timer);timer=null;remaining=Math.max(0,remaining-(performance.now()-started));}}
 function remember(){shown=true;pauseTimer();try{sessionStorage.setItem(key,'shown');localStorage.setItem(key,String(Date.now()));}catch{}}
 function openOffer(){if(dialog.open)return;remember();returnFocus=document.activeElement;dialog.showModal();document.documentElement.classList.add('offer-open');launcher.hidden=true;}
 function closeOffer(){dialog.close();}
 function schedule(){pauseTimer();if(shown||document.hidden)return;started=performance.now();timer=setTimeout(()=>{timer=null;remaining=0;const active=document.activeElement;if(active?.matches('input,select,textarea,[contenteditable="true"]')||document.querySelector('dialog[open]')){remaining=3000;schedule();return;}openOffer();},remaining);}
 launcher.hidden=false;launcher.addEventListener('click',openOffer);
 dialog.querySelector('.offer-close').addEventListener('click',closeOffer);
 dialog.querySelector('.offer-dismiss').addEventListener('click',closeOffer);
 dialog.querySelector('#offer-claim').addEventListener('click',()=>{returnFocus=null;dialog.dataset.claimed='true';closeOffer();});
 dialog.addEventListener('close',()=>{remember();document.documentElement.classList.remove('offer-open');launcher.hidden=false;if(dialog.dataset.claimed==='true'){delete dialog.dataset.claimed;const contact=document.querySelector('#contact');contact.scrollIntoView({behavior:motionReduced()?'instant':'smooth'});const link=contact.querySelector('a');link.focus({preventScroll:true});}else if(returnFocus&&returnFocus!==document.body&&returnFocus.isConnected)returnFocus.focus({preventScroll:true});else launcher.focus({preventScroll:true});});
 dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeOffer();});
 document.addEventListener('visibilitychange',schedule);schedule();
})();

// V10: margin remains a first-class buying tool within one compact assistant.
document.querySelectorAll('[data-open-tool]').forEach(link=>link.addEventListener('click',()=>activate(link.dataset.openTool)));
activate('margin');

// Open the warranty details when reached from the homepage assurance strip.
document.querySelectorAll('[data-open-warranty]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();const details=document.querySelector('#quality-warranty');details.open=true;details.scrollIntoView({behavior:motionReduced()?'instant':'smooth'});details.querySelector('summary').focus({preventScroll:true});}));



// --- Lightbox with Full-Res New Tab Link ---
const certGalleryData = [
  {
    title: "IATF 16949:2016 Quality Management Certificate",
    sub: "AENOR Audited Facility (Cert #RA02-0713/2023, valid through Dec 2026) · [Confidential OEM Facility Redacted]",
    src: ""
  },
  {
    title: "ARDL US Lab Test Report (SAE J903 Cover)",
    sub: "Report PN 185243 - Akron Rubber Development Laboratory (Ohio, USA) · [Client Identifier Redacted]",
    src: ""
  },
  {
    title: "Model 799: 1,500,000 Sweep Durability Data Table",
    sub: "Report PN 185243 Page 3 - Quadrant Ratings Grade 6–7 (SAE J903) · [Client Identifier Redacted]",
    src: ""
  },
  {
    title: "Model 818: Intertek Test Report & Quality Seal",
    sub: "Report #250063000-AMQS-6 - Conventional Wiper Blade SAE J903-2024.10 · [OEM Partner Redacted]",
    src: ""
  },
  {
    title: "TÜV SÜD: 150-Hour Salt Spray & Corrosion Test Pass",
    sub: "Report #70.435.26.10201.02R1 - ISO 9227 Neutral Salt Spray Test · [Client Identifier Redacted]",
    src: ""
  }
];

let currentCertIndex = 0;

function switchCert(index) {
  if (index < 0) index = 0;
  if (index >= certGalleryData.length) index = certGalleryData.length - 1;
  currentCertIndex = index;
  const cert = certGalleryData[index];
  
  const dialog = document.querySelector('#cert-lightbox');
  const img = document.querySelector('#cert-dialog-img');
  const h3 = document.querySelector('#cert-dialog-title');
  const sub = document.querySelector('#cert-dialog-sub');
  const counter = document.querySelector('#cert-nav-counter');
  const zoomLink = document.querySelector('#cert-dialog-zoom-link');
  const pills = document.querySelectorAll('.cert-pill-item');

  if (img) img.src = cert.src;
  if (h3) h3.textContent = cert.title;
  if (sub) sub.textContent = cert.sub;
  if (counter) counter.textContent = `Sheet ${index + 1} of ${certGalleryData.length}`;
  if (zoomLink) zoomLink.href = cert.src;

  pills.forEach((p, i) => {
    p.classList.toggle('active', i === index);
  });
}

function prevCert() {
  let idx = currentCertIndex - 1;
  if (idx < 0) idx = certGalleryData.length - 1;
  switchCert(idx);
}

function nextCert() {
  let idx = currentCertIndex + 1;
  if (idx >= certGalleryData.length) idx = 0;
  switchCert(idx);
}

function openCertGallery(index = 0) {
  const dialog = document.querySelector('#cert-lightbox');
  if (!dialog) return;
  switchCert(index);
  dialog.showModal();
}

function openCertLightbox(src, title) {
  // Find index in certGalleryData if matching
  const idx = certGalleryData.findIndex(c => c.src === src);
  if (idx !== -1) {
    openCertGallery(idx);
  } else {
    const dialog = document.querySelector('#cert-lightbox');
    const img = document.querySelector('#cert-dialog-img');
    const h3 = document.querySelector('#cert-dialog-title');
    const zoomLink = document.querySelector('#cert-dialog-zoom-link');
    if (!dialog || !img) return;
    img.src = src;
    if (h3 && title) h3.textContent = title;
    if (zoomLink) zoomLink.href = src;
    dialog.showModal();
  }
}

function closeCertLightbox() {
  const dialog = document.querySelector('#cert-lightbox');
  if (dialog) dialog.close();
}

// --- Enhanced Margin Calculator with First-Order 10% Toggle ---
(function initCalculator() {
  const modelSelect = document.querySelector('#margin-model');
  const tierSelect = document.querySelector('#margin-tier');
  const firstOrderCheck = document.querySelector('#first-order-check');
  const costInput = document.querySelector('#margin-cost');
  const saleInput = document.querySelector('#margin-sale');
  const otherInput = document.querySelector('#margin-other');
  const resElem = document.querySelector('#margin-result');
  const pctElem = document.querySelector('#margin-percent');
  const hintElem = document.querySelector('#cost-hint');

  const basePrices = { '799': 14.40, '818': 10.80 };
  const tierDiscounts = { 'base': 0, 'volume': 0.10, 'dealer': 0.15, 'bulk': 0.20 };

  function calculate() {
    if (!modelSelect || !costInput) return;
    const model = modelSelect.value;
    const base = basePrices[model] || 14.40;
    const tier = tierSelect.value;
    let discount = tierDiscounts[tier] || 0;

    let discountNote = '';
    if (firstOrderCheck && firstOrderCheck.checked) {
      if (discount < 0.10) {
        discount = 0.10;
        discountNote = ' (10% first-order discount applied)';
      } else {
        discountNote = ' (Higher volume discount applied; discounts do not combine)';
      }
    } else if (discount > 0) {
      discountNote = ' (' + (discount * 100) + '% volume tier applied)';
    }

    const netCost = base * (1 - discount);
    costInput.value = netCost.toFixed(2);

    const sale = parseFloat(saleInput.value) || 0;
    const other = parseFloat(otherInput.value) || 0;
    const margin = sale - netCost - other;
    const pct = sale > 0 ? (margin / sale) * 100 : 0;

    resElem.textContent = '$' + margin.toFixed(2);
    pctElem.textContent = pct.toFixed(1) + '%';
    hintElem.textContent = (model === '799' ? '799 Beam' : '818 Conventional') + ' 20″ · Net cost: $' + netCost.toFixed(2) + '/blade' + discountNote;
  }

  [modelSelect, tierSelect, firstOrderCheck, saleInput, otherInput].forEach(el => {
    if (el) el.addEventListener('input', calculate);
  });
  calculate();
})();

// --- Multi-Line Restock Order Builder ---
(function initOrderPlanner() {
  const container = document.querySelector('#order-lines-container');
  const addBtn = document.querySelector('#add-order-line-btn');
  const summaryLine = document.querySelector('#summary-line');
  const summaryTotal = document.querySelector('#summary-total');
  const waBtn = document.querySelector('#send-wa-order-btn');
  const copyBtn = document.querySelector('#copy-order-btn');
  const statusElem = document.querySelector('#copy-status');

  if (!container || !addBtn) return;

  const sizes = ['14', '15', '16', '17', '18', '19', '20', '21', '22', '24', '26', '28'];

  function createOrderLine(defaultModel = '799', defaultSize = '20', defaultBoxes = 1) {
    const row = document.createElement('div');
    row.className = 'order-line-row';
    row.innerHTML = `
      <select class="line-model">
        <option value="799" ${defaultModel==='799'?'selected':''}>799 Beam</option>
        <option value="818" ${defaultModel==='818'?'selected':''}>818 Conventional</option>
      </select>
      <select class="line-size">
        ${sizes.map(s => `<option value="${s}" ${s===defaultSize?'selected':''}>${s}″</option>`).join('')}
      </select>
      <input type="number" class="line-boxes" min="1" max="500" value="${defaultBoxes}" title="Boxes (50 blades/box)">
      <span class="line-blades">${defaultBoxes * 50} blades</span>
      <button type="button" class="line-remove" title="Remove line">×</button>
    `;

    row.querySelector('.line-boxes').addEventListener('input', (e) => {
      const b = parseInt(e.target.value) || 0;
      row.querySelector('.line-blades').textContent = (b * 50) + ' blades';
      updateSummary();
    });
    row.querySelector('.line-model').addEventListener('change', updateSummary);
    row.querySelector('.line-size').addEventListener('change', updateSummary);
    row.querySelector('.line-remove').addEventListener('click', () => {
      if (container.children.length > 1) {
        row.remove();
        updateSummary();
      }
    });

    container.appendChild(row);
    updateSummary();
  }

  function getOrderData() {
    const lines = [];
    let totalBoxes = 0;
    container.querySelectorAll('.order-line-row').forEach(row => {
      const model = row.querySelector('.line-model').value;
      const size = row.querySelector('.line-size').value;
      const boxes = parseInt(row.querySelector('.line-boxes').value) || 0;
      if (boxes > 0) {
        lines.push({ model, size, boxes, blades: boxes * 50 });
        totalBoxes += boxes;
      }
    });
    return { lines, totalBoxes, totalBlades: totalBoxes * 50 };
  }

  function updateSummary() {
    const data = getOrderData();
    summaryLine.textContent = `Total: ${data.totalBoxes} ${data.totalBoxes === 1 ? 'box' : 'boxes'}`;
    summaryTotal.textContent = `${data.totalBlades.toLocaleString()} blades`;
  }

  addBtn.addEventListener('click', () => {
    createOrderLine('799', '22', 1);
  });

  // Initialize with 2 practical lines
  createOrderLine('799', '20', 1);
  createOrderLine('799', '22', 1);

  // Send to WhatsApp
  if (waBtn) {
    waBtn.addEventListener('click', () => {
      const data = getOrderData();
      if (data.lines.length === 0) return;
      let text = 'Hello Fartilo Team, I would like a wholesale quote for:\n';
      data.lines.forEach((l, idx) => {
        text += `${idx + 1}. Fartilo ${l.model} (${l.size}″) - ${l.boxes} box(es) [${l.blades} blades]\n`;
      });
      text += `Total: ${data.totalBoxes} boxes (${data.totalBlades} blades). Destination ZIP: [Enter your ZIP]`;
      const url = 'https://wa.me/14808738062?text=' + encodeURIComponent(text);
      window.open(url, '_blank');
      statusElem.textContent = 'Redirecting to WhatsApp with your restock list pre-filled...';
    });
  }

  // Copy Order List
  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      const data = getOrderData();
      if (data.lines.length === 0) return;
      let text = 'Fartilo Wiper Restock Request:\n';
      data.lines.forEach((l, idx) => {
        text += `${idx + 1}. Fartilo ${l.model} - ${l.size}" - ${l.boxes} box(es) (${l.blades} blades)\n`;
      });
      text += `Total: ${data.totalBoxes} boxes (${data.totalBlades} blades)\nContact: info@fartiloauto.com | Tel: +1 (480) 873-8062`;

      try {
        await navigator.clipboard.writeText(text);
        statusElem.textContent = 'Copied to clipboard! Paste it into an email to info@fartiloauto.com.';
      } catch (err) {
        statusElem.textContent = 'Select and copy: ' + text;
      }
    });
  }
})();

function openWarrantyModal() {
  const dialog = document.querySelector('#quality-warranty');
  if (dialog) dialog.showModal();
}
function closeWarrantyModal() {
  const dialog = document.querySelector('#quality-warranty');
  if (dialog) dialog.close();
}
// Attach to any warranty triggers
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-open-warranty], a[href="#quality-warranty"]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openWarrantyModal();
    });
  });
});

